import React from "react";
import cx from "clsx";
import VIEW_ICON from "../../../Clients/Documents/icons/view.svg";
import { checkIfPermissionAllowed } from "../../../../Utils";
import classes from "../scss/expirationActionButtons.module.scss";

const ExpirationActionButtons = ({
  document,
  reportSysName,
  setSelectedDocument,
}) => {
  const canView = checkIfPermissionAllowed("view-documents");
  const isDocumentsExpiration = reportSysName === "documents-expiration";
  const isLocked = !isDocumentsExpiration && Boolean(document.is_lock);

  if (!canView) {
    return null;
  }

  return (
    <div className="flex justify-center gap-8">
      <button
        className={cx("header-unselect-btn", "modal-link", classes.viewIcon)}
        disabled={isLocked}
        onClick={() => {
          if (isDocumentsExpiration) {
            window.open(document.file_url, "_blank", "noopener,noreferrer");
          } else if (!isLocked) {
            setSelectedDocument(document);
          }
        }}
      >
        <img
          src={VIEW_ICON}
          className={cx("min-w-16", {
            "cursor-pointer": !isLocked,
            "cursor-not-allowed": isLocked,
          })}
          title="View"
          width={16}
          height={16}
          alt=""
        />
      </button>
    </div>
  );
};

export default ExpirationActionButtons;
